export const displayModeList = [
  { value: 'list' },
  { value: 'thumbnail' },
]
